import { z } from 'zod';
import { BaseEntitySchema } from './common';
import { ImageId, PlayerGroupId, PlayerId, UserId } from './ids';

export const PlayerGroupNameSchema = z
  .string()
  .max(100)
  .refine((value) => value.trim().length > 0, {
    message: 'Name must have at least 1 non-space character',
  });

export const PlayerGroupDescriptionSchema = z
  .string()
  .max(200)
  .optional()
  .transform((value) => (value?.trim() ? value.trim() : undefined));

export const PlayerGroupSchema = BaseEntitySchema.extend({
  id: PlayerGroupId,
  name: PlayerGroupNameSchema,
  description: PlayerGroupDescriptionSchema,
  playerIds: z.array(PlayerId).min(1),
  userId: UserId.optional(),
  avatarImageId: ImageId.optional(),
});

export type PlayerGroup = z.infer<typeof PlayerGroupSchema>;
